<!-- Table -->
<div class="table-responsive">
  <table class="table table-borderless table-nowrap">
    <thead class="table-light">
      <tr>
        <th scope="col">{{ 'competitionModule.rank' | translate }}</th>
        <th scope="col">{{ 'competitionModule.player' | translate }}</th>
        <th scope="col">{{ 'competitionModule.team' | translate }}</th>
        <th scope="col">{{ 'competitionModule.goals' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let scorer of topScorers$ | async">
        <td>
          <strong>{{ scorer.position }} </strong>
        </td>
        <td>
          {{
            (memberEntities$ | async)[
              (competitionPlayerEntities$ | async)[scorer.competitionPlayerId1]
                ?.memberId
            ]?.firstName
          }}
          {{
            (memberEntities$ | async)[
              (competitionPlayerEntities$ | async)[scorer.competitionPlayerId1]
                ?.memberId
            ]?.middleName
          }}
          {{
            (memberEntities$ | async)[
              (competitionPlayerEntities$ | async)[scorer.competitionPlayerId1]
                ?.memberId
            ]?.lastName
          }}
        </td>
        <td>
          {{
            (competitionTeamEntities$ | async)[scorer.competitionTeamId]
              ?.description
          }}
        </td>
        <td>{{ scorer.amount }}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- End Table -->
